import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: ['./payment-failed.component.scss']
})
export class PaymentFailedComponent {
  constructor(private router: Router) {}

goBackToApp() {
  window.location.href = 'https://monkey-pen-app-dev.techlabz.in/';
}
}
